import axios from 'axios';
import { createAsyncThunk, createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { appendCriteriaContains, appendCriteriaEquals, appendPageable, readPagedRows, } from '../utils/spring-api';
import { serializeAxiosError, resolveAsyncThunkErrorMessage, beginReportFetch, isStaleReportRequest, isAbortedThunkError } from './reducer.utils';
const initialState = {
    loading: false,
    errorMessage: null,
    report: [],
    totalItems: 0,
    activeRequestId: null,
};
const apiUrl = API_ROUTES.qstat.sessionReport;
function buildParams(params) {
    const q = new URLSearchParams();
    appendCriteriaContains(q, 'username', params.username);
    appendCriteriaContains(q, 'activity', params.activity);
    appendCriteriaEquals(q, 'startDate', params.startDate);
    appendCriteriaEquals(q, 'endDate', params.endDate);
    appendPageable(q, params.page, params.size, params.sort ?? 'loginTime,desc');
    return q;
}
export async function fetchSessionReportRows(params, options) {
    const q = buildParams(params);
    const res = await axios.get(`${apiUrl}?${q.toString()}`, { signal: options?.signal });
    const { rows, total } = readPagedRows(res.data, res.headers);
    return { rows, total };
}
export const getSessionReport = createAsyncThunk('sessionReport/fetch', async (params, { signal }) => fetchSessionReportRows(params, { signal }), { serializeError: serializeAxiosError });
export const SessionReportSlice = createSlice({
    name: 'sessionReport',
    initialState: initialState,
    reducers: {
        reset() {
            return initialState;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getSessionReport.fulfilled, (state, action) => {
            if (isStaleReportRequest(state, action))
                return;
            state.loading = false;
            state.report = action.payload.rows;
            state.totalItems = action.payload.total;
        })
            .addMatcher(isPending(getSessionReport), (state, action) => {
            beginReportFetch(state, action, () => {
                state.report = [];
            });
        })
            .addMatcher(isRejected(getSessionReport), (state, action) => {
            if (isStaleReportRequest(state, action))
                return;
            if (isAbortedThunkError(action.error))
                return;
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { reset } = SessionReportSlice.actions;
export default SessionReportSlice.reducer;
